import Vue from "vue";
import App from "./App.vue";
import router from "./router";


import '@/iconfont/iconfont.css'
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/less/style.less'
import '@/assets/less/reset.less'

import store from './store'
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Vant)
Vue.config.productionTip = false;
Vue.prototype.$Toast = Toast;



new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
